import { render } from "./EventParticipationEmailRenderer.vue?vue&type=template&id=7bbbb932&ts=true"
import script from "./EventParticipationEmailRenderer.vue?vue&type=script&lang=ts"
export * from "./EventParticipationEmailRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__